import api, { isAuthenticated } from './api'
import { Locale } from '../types'

export interface Favorito {
  id: number
  localeId: number
  notePersonali?: string
  createdAt: string
  locale: Locale
}

/**
 * Ottiene lista preferiti dell'utente
 */
export async function getFavoriti(): Promise<Favorito[]> {
  if (!isAuthenticated()) return []
  try {
    return await api.get<Favorito[]>('/favoriti')
  } catch {
    return []
  }
}

/**
 * Ottiene solo gli ID dei locali preferiti
 */
export async function getFavoritiIds(): Promise<number[]> {
  const favoriti = await getFavoriti()
  return favoriti.map(f => f.localeId)
}

/**
 * Aggiunge locale ai preferiti
 */
export async function addFavorito(localeId: number): Promise<void> {
  await api.post(`/favoriti/${localeId}`)
}

/**
 * Rimuove locale dai preferiti
 */
export async function removeFavorito(localeId: number): Promise<void> {
  await api.delete(`/favoriti/${localeId}`)
}

/**
 * Toggle preferito
 */
export async function toggleFavorito(localeId: number, isFavorito: boolean): Promise<void> {
  if (isFavorito) {
    await removeFavorito(localeId)
  } else {
    await addFavorito(localeId)
  }
}

/**
 * Aggiorna note personali
 */
export async function updateNoteFavorito(localeId: number, notePersonali: string): Promise<void> {
  await api.patch(`/favoriti/${localeId}`, { notePersonali })
}
